import Vue from 'vue'
import { Notification } from 'element-ui'

export default async (otp) => {
  try {
    return await Vue.axios.post('/auth/otp_email', {otp})
  } catch (e) {
    Notification({message: 'Mã xác thực không chính xác!', showClose: false, duration: 3000, customClass: 'error'})
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/check-otp.js